<template lang='pug'>
  transition(name='slide')
    .mobile-filters(v-if='showMobileFilter')
      .mobile-header.row
        .col-3.header-action(@click='showOverlay ? filterBack() : filterClose()')
          .svg-icon(:class='showOverlay ? "chevron-left" : "close2"')
        .col-6
          h3.header-title.h3(v-text='filterText')
        .col-3.header-action
          template(v-if='anyFiltersApplied')
            .filter-clear-btn(@click='resetCurrentFilter' v-t='"clear"' v-if='showOverlay')
            .filter-clear-btn(@click='resetAllFilters' v-t='"buttons.clearAll"' v-else)

      .filter-list
        .card.card-light.filter-card(v-for='(filter, index) in filterList' :key='index' v-if='!filter.disabled')
          .filter-price-container(v-if='filter.type === "prices"')
            span.h4.filter-page-title(v-text='filter.label')
            products-price-filter
          a(v-else @click.prevent='setCurrentFilterPage(filter.type)')
            span.h4.filter-page-title(v-text='filter.label')
            span.filter-page-selection(v-if='filter.filtered' v-text='filter.list')
            .svg-icon.chevron-right.slide-arrow

          transition(name='slide')
            template(v-if='currentFilterType === "categories"')
              category-filter-overlay(v-once :model='rootCategories')

            .overlay(v-if='currentFilterType === "brands"')
              .form-group.floating-labels.search-form(:class='{ "focused": displayBrandSearch }')
                label.control-label.search-placeholder(for='filter-brands-search' v-text='$t("products.brand.searchBrands")')
                input.filter-brands-search(type='text' v-model='displayBrandSearch')
                span.filter-brands-search-icon.svg-icon.search-black
              .filter-value-list.filter-brands
                .card.card-light.filter-card.form-check(v-for='brand in displayBrands')
                  a.filter-option.form-check-label(href='#0' @click.prevent.self='toggleFilterBrandSlugs(brand.attributes["slug-url"])')
                    span(:class='`filter-span-brand-${brand.attributes["slug-url"]}`' v-text='brand.attributes.name')
                    span.filter-svg.form-check-input.checkbox(:class='[`filter-svg-brand-${brand.attributes["slug-url"]}`, { "checked": isBrandSelected(brand) }]')

            .overlay(v-else-if='findMatchingCustomFilter(currentFilterType)')
              .card.card-light.filter-card.form-check(v-for='filterValue in filterValuesFor(findMatchingCustomFilter(currentFilterType))')
                a.filter-option.form-check-label(href='#0' @click.prevent.self='toggleFilterCustomSlugs({ type: findMatchingCustomFilter(currentFilterType), value: filterValue })')
                  span(:class='`filter-span-${customFilterClass(findMatchingCustomFilter(currentFilterType).attributes.name)}-${customFilterClass(filterValue.attributes.value)}`' v-text='filterValue.attributes.value')
                  span.filter-svg.form-check-input.checkbox(:class='[`filter-svg-${customFilterClass(findMatchingCustomFilter(currentFilterType).attributes.name)}-${customFilterClass(filterValue.attributes.value)}`, { "checked": isCustomValueSelected(findMatchingCustomFilter(currentFilterType), filterValue) }]')

            .overlay(v-else-if='currentFilterType === "others"')
              .card.card-light.filter-card.form-check(v-if='availableOtherFilters.indexOf("on_sale") !== -1')
                a.filter-option.form-check-label(:class='{ "active": filterOthers && filterOthers.indexOf("on_sale") !== -1 }' href='#0' @click.prevent.self='toggleFilterOthers("on_sale")')
                  span.filter-span-other-on-sale(v-t='"products.filters.onSale"')
                  span.filter-svg.form-check-input.checkbox.filter-svg-other-on-sale(:class='{ "checked": filterOthers && filterOthers.indexOf("on_sale") !== -1 }')

      .mobile-filter-actions
        button.btn.btn-lg.btn-block(v-if='showViewResultsWithCount' @click='filterApply' v-text='$tc("viewResultsWithCount", productsCount, { count: productsCount })')
        button.btn.btn-lg.btn-block(v-else-if='showViewResults' @click='filterApply' v-t='"viewResults"')
        button.btn.btn-lg.btn-block.btn-white(v-else @click='filterApply' v-t='"buttons.close"')
</template>

<i18n>
{
  "lng_en": {
    "viewResults": "View Results",
    "viewResultsWithCount": "View {count} Result | View {count} Results",
    "clear": "Clear"
  },
  "lng_id": {
    "viewResults": "View Results",
    "viewResultsWithCount": "View {count} Result | View {count} Results",
    "clear": "Clear"
  },
  "lng_th": {
    "viewResults": "View Results",
    "viewResultsWithCount": "View {count} Result | View {count} Results",
    "clear": "Clear"
  },
  "lng_zh": {
    "viewResults": "View Results",
    "viewResultsWithCount": "View {count} Result | View {count} Results",
    "clear": "Clear"
  },
  "lng_ko": {
    "viewResults": "결과 보기",
    "viewResultsWithCount": "결과 {count} 보기 | 결과 {count} 보기",
    "clear": "지우기"
  }
}
</i18n>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import CategoryFilterOverlay from './category-filter-overlay.vue'
import ProductsPriceFilter from './products-price-filter.vue'

export default {
  components: {
    CategoryFilterOverlay,
    ProductsPriceFilter
  },

  data () {
    return {
      displayBrandSearch: '',
      currentFilterType: '',
      showOverlay: false,
      filterSources: {},
      rootCategories: {}
    }
  },

  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entityType: state => state.product.entityType,
      entitySlug: state => state.product.entitySlug,
      productsCount: state => state.product.productsCount,
      productsLoading: state => state.product.productsLoading,
      availableBrands: state => state.product.availableBrands,
      availableCustomFilters: state => state.product.availableCustomFilters,
      availableCustomFilterValues: state => state.product.availableCustomFilterValues,
      availableOtherFilters: state => state.product.availableOtherFilters,
      filterCategorySlug: state => state.category.filterCategorySlug,
      filterBrandSlugs: state => state.product.filterBrandSlugs,
      filterPrice: state => state.product.filterPrice,
      filterCustomSlugs: state => state.product.filterCustomSlugs,
      filterOthers: state => state.product.filterOthers,
      filterCategoryTrail: state => state.category.filterCategoryTrail,
      showMobileFilter: state => state.layout.showMobileFilter,
      showViewResults: state => state.product.showViewResults,
      showViewResultsWithCount: state => state.product.showViewResultsWithCount
    }),

    ...mapGetters([
      'entityPath',
      'activeCategory',
      'activeFirstLevelCategories',
      'activeCategoryPage',
      'childCategoriesSizeFor',
      'filterValuesFor',
      'filterTypeFor'
    ]),

    filterList () {
      let customFilters = []
      if (this.entityType === 'categories') {
        customFilters = this.availableCustomFilters.map(f => {
          return {
            type: f.attributes.name,
            label: f.attributes.name,
            filtered: this.filterCustomSlugs.length > 0,
            list: this.filterCustomList(f)
          }
        })
      }
      return [
        {
          type: 'categories',
          label: this.$t('products.category.title'),
          filtered: this.isCategoryFilterApplied,
          list: (this.activeCategory.attributes) ? this.activeCategory.attributes.label : '',
          disabled: (this.entityType === 'categories' || this.rootCategories.category) ? this.childCategoriesSizeFor(this.rootCategories.category) === 0 : false
        },
        ...((this.displayBrands && this.displayBrands.length > 0) || !!this.displayBrandSearch ? [{
          type: 'brands',
          label: this.$t('products.brand.title'),
          filtered: this.filterBrandSlugs.length > 0,
          list: this.filterBrandsList
        }] : []),
        {
          type: 'prices',
          label: this.$t('products.filters.price'),
          filtered: this.filterPrice.max || this.filterPrice.min
        },
        ...customFilters,
        ...(this.displayOtherFilters ? [{
          type: 'others',
          label: this.$t('products.filters.others'),
          filtered: this.filterOthers && this.filterOthers.indexOf('on_sale') !== -1,
          list: this.$t('products.filters.onSale')
        }] : [])
      ]
    },

    filterText () {
      if (this.currentFilterType) {
        if (this.filterCategoryTrail.length > 0) {
          return this.filterCategoryTrail.slice(-1).pop().attributes.label
        }
        return this.currentFilterType
      }
      return this.$t('products.filters.title')
    },

    filterBrandsList () {
      return this.filterBrandSlugs.map(b => {
        const brands = this.availableBrands.find(brand => brand.attributes['slug-url'] === b)
        if (!brands) {
          return
        }
        return this.availableBrands.find(brand => brand.attributes['slug-url'] === b).attributes.name
      }).filter(b => b !== undefined).sort().join(', ')
    },

    displayBrands () {
      if (this.displayBrandSearch) {
        return this.availableBrands.filter(brand => brand.attributes.name.toLowerCase().includes(this.displayBrandSearch.toLowerCase()))
      } else {
        return this.availableBrands
      }
    },

    displayOtherFilters () {
      return (this.availableOtherFilters && this.availableOtherFilters.length > 0 && this.entitySlug !== 'sale')
    },

    anyFiltersApplied () {
      if (this.currentFilterType === 'categories') {
        return this.isCategoryFilterApplied
      } else if (this.currentFilterType === 'brands') {
        return !!this.displayBrandSearch || this.filterBrandSlugs.length > 0
      } else if (this.currentFilterType === 'others') {
        return this.filterOthers.length > 0
      } else if (this.currentFilterType) {
        return this.filterCustomSlugs.find(f => f.type.attributes.name === this.currentFilterType)
      } else {
        return !!this.displayBrandSearch ||
          this.filterBrandSlugs.length > 0 ||
          Object.keys(this.filterPrice).length !== 0 ||
          this.filterOthers.length > 0 ||
          this.filterCustomSlugs.length > 0 ||
          this.isCategoryFilterApplied
      }
    },

    isCategoryFilterApplied () {
      if (!this.activeCategory.attributes) {
        return false
      }
      if (this.filterCategoryTrail.length > 0) { // handle category filter
        const currentCategoryPage = this.filterCategoryTrail.slice(-1).pop()
        if (currentCategoryPage.id === this.activeCategory.id) { // handle select all option
          if (this.filterCategoryTrail.length === 1) { // on root category page
            if (this.entityType === 'categories') {
              return false
            }
            return !this.rootCategories.category
          }
          return true
        }
        return this.activeCategory.attributes['slug-url'].indexOf(currentCategoryPage.attributes['slug-url']) !== -1
      } else { // handle root filter
        if (this.entityType !== 'categories') {
          if (!this.rootCategories.category && this.filterCategorySlug) {
            return true
          } else if (this.rootCategories.category && this.filterCategorySlug !== this.rootCategories.category.attributes['slug-url']) {
            return true
          }
          return false
        }
        return this.rootCategories.category && this.rootCategories.category.id !== this.activeCategory.id
      }
    }
  },

  watch: {
    showMobileFilter () {
      if (this.showMobileFilter) {
        this.setRootCategories()
        document.body.style.overflow = 'hidden'
        this.filterSources = {
          path: this.$route.path,
          fullPath: this.$route.fullPath,
          filterBrandSlugs: this.cloneDeep(this.filterBrandSlugs),
          filterPrice: this.cloneDeep(this.filterPrice),
          filterCustomSlugs: this.cloneDeep(this.filterCustomSlugs),
          filterOthers: this.cloneDeep(this.filterOthers)
        }
      } else {
        document.body.style.overflow = 'auto'
      }
    },

    productsLoading () {
      if (!this.productsLoading && this.showViewResults) {
        this.$store.commit('setShowViewResultsWithCount', true)
      } else {
        this.$store.commit('setShowViewResultsWithCount', false)
      }
    }
  },

  methods: {
    ...mapMutations([
      'toggleFilterBrandSlugs',
      'toggleFilterOthers'
    ]),

    ...mapActions([
      'toggleFilterCustomSlugs'
    ]),

    cloneDeep (state) {
      if (state) {
        return JSON.parse(JSON.stringify(state))
      }
      return state
    },

    isBrandSelected (brand) {
      return this.filterBrandSlugs.indexOf(brand.attributes['slug-url']) !== -1
    },

    isCustomValueSelected (type, value) {
      const filter = this.filterCustomSlugs.find(f => f.type.id === type.id)
      return filter && filter.values.find(v => v.id === value.id)
    },

    findMatchingCustomFilter (type) {
      return this.availableCustomFilters.find(f => f.attributes.name === type)
    },

    filterCustomList (type) {
      const filter = this.filterCustomSlugs.find(f => f.type.id === type.id)
      if (filter) {
        return filter.values.map(v => v.attributes.value).join(', ')
      }
    },

    resetAllFilters () {
      this.displayBrandSearch = null
      this.$store.dispatch('resetAllFilters')
      if (this.entityType === 'categories') {
        this.$router.replace(this.filterSources.path)
      }
    },

    resetCurrentFilter () {
      if (this.currentFilterType === 'categories') {
        if (this.entityType === 'categories') {
          this.$router.replace(this.filterSources.fullPath)
        } else {
          this.$router.replace({ name: this.$route.name, params: { id: this.$route.params.id } })
        }
      } else if (this.currentFilterType === 'brands') {
        this.$store.commit('setFilterBrandSlugs', [])
      } else if (this.currentFilterType === 'others') {
        this.$store.commit('setFilterOthers', [])
      } else {
        const filter = this.filterCustomSlugs.concat()
        const index = filter.findIndex(f => f.type.attributes.name === this.currentFilterType)
        filter.splice(index, 1)
        this.$store.commit('setFilterCustomSlugs', filter)
      }
      this.$store.commit('setShowViewResults', true)
    },

    customFilterClass (label) {
      return label.toLowerCase().split(' ').join('_')
    },

    filterUndo () {
      if (this.filterSources.path !== this.$route.path) {
        this.$router.replace(this.filterSources.fullPath)
      }
      if (this.filterSources.filterBrandSlugs.join() !== this.filterBrandSlugs.join()) {
        this.$store.commit('setFilterBrandSlugs', this.filterSources.filterBrandSlugs)
      }
      if (this.filterSources.filterPrice.min !== this.filterPrice.min || this.filterSources.filterPrice.max !== this.filterPrice.max) {
        this.$store.commit('setFilterPrice', this.filterSources.filterPrice)
      }
      if (this.filterSources.filterOthers.join() !== this.filterOthers.join()) {
        this.$store.commit('setFilterOthers', this.filterSources.filterOthers)
      }
      if (this.filterSources.filterCustomSlugs.join() !== this.filterCustomSlugs.join()) {
        this.$store.commit('setFilterCustomSlugs', this.filterSources.filterCustomSlugs)
      }
    },

    filterClose () {
      this.filterUndo()
      this.filterApply()
    },

    filterApply () {
      this.clearFilterHistory()
      this.$store.commit('setShowMobileFilter', false)
      this.$store.commit('setShowViewResults', false)
      this.$store.commit('setShowViewResultsWithCount', false)
      this.$store.commit('setPage', 1)
    },

    filterBack () {
      if (!this.showOverlay) {
        this.$store.commit('setShowMobileFilter', false)
      }

      if (this.currentFilterType === 'categories') {
        if (this.filterCategoryTrail.length === 0 && this.entityType !== 'categories') {
          this.clearFilterHistory()
        }
        this.$store.commit('setFilterCategoryTrail', { pop: true })
        if (this.filterCategoryTrail.length === 0 && (this.entityType === 'categories' || this.rootCategories.category)) {
          this.clearFilterHistory()
        }
      } else {
        this.clearFilterHistory()
      }
    },

    setCurrentFilterPage (filter) {
      if (filter) {
        this.currentFilterType = filter
        this.showOverlay = true
        if (this.currentFilterType === 'categories' && this.rootCategories.category) {
          this.$store.commit('setFilterCategoryTrail', { push: this.rootCategories.category })
        }
      }
    },

    setRootCategories () {
      if (this.entityType === 'categories') {
        this.rootCategories = {
          category: this.activeCategory,
          tier: 0,
          children: [],
          isRoot: true
        }
      } else {
        this.rootCategories = {
          category: null,
          tier: -1,
          children: this.activeFirstLevelCategories.map(firstLevel => {
            return { category: firstLevel, tier: 0, children: [] }
          }),
          isRoot: true
        }
      }
    },

    clearFilterHistory () {
      this.currentFilterType = ''
      this.showOverlay = false
      this.$store.commit('setFilterCategoryTrail', { clear: true })
    }
  }
}
</script>

<style lang='scss'>
  .slide-leave-active,
  .slide-enter-active {
    transition: .3s;
  }

  .slide-enter {
    transform: translate(100%, 0);
  }

  .slide-leave-to {
    transform: translate(100%, 0);
  }

  .filter-svg {
    position: absolute;
    right: 10px;
    pointer-events: none;
  }

  .slide-arrow {
    position: absolute;
    top: 12px;
    right: 18px;
    height: 20px;
    width: 20px;
  }

  .filter-list {
    height: 100%;
    padding-bottom: 170px;
    overflow-y: auto;
  }

  .filter-card {
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-width: 1px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    a {
      color: inherit;
      display: flex;
      padding: 14px 20px 12px;
      white-space: nowrap;
      width: 100%;
    }

    .filter-page-selection {
      @include font-weight-book;
      margin-left: 15px;
      margin-right: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: $grey-dark;
      text-transform: capitalize;
    }

    .filter-page-title {
      line-height: inherit;
      text-transform: uppercase;
    }

    .filter-option-container {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .filter-option {
      padding: 12px 24px;
      display: inline-block;
      width: 100%;

      &.h4 {
        text-transform: uppercase;
      }

      &.active {
        @include font-weight-medium;
      }

      span,
      .svg-icon {
        pointer-events: none;
      }
    }
  }

  .mobile-filters {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: $zindex-fixed;
    background: $white;

    .overlay {
      width: 100%;
      height: 100%;
      padding-bottom: 100px;
      position: fixed;
      top: 60px;
      bottom: 40px;
      left: 0;
      z-index: $zindex-fixed;
      background: $white;
      overflow-y: scroll;
    }
  }

  .filter-value-list {
    height: 100%;
    width: 100%;
    position: absolute;
    overflow-y: auto;
    padding-bottom: 150px;
  }
</style>

<style lang='scss' scoped>
  .filter-price-container {
    width: 100%;
    padding: 14px 20px 12px;

    .range-slider {
      padding: 0;
      margin-top: 5px;
    }
  }

  .search-form {
    border-bottom: 1px solid $grey;
    padding-left: 15px;

    .filter-brands-search {
      border: 0;
      height: 45px;
      width: 90%;
    }

    .search-placeholder {
      line-height: 25px;
      padding-left: 15px;
      pointer-events: none;
    }

    .filter-brands-search-icon {
      position: absolute;
      right: 20px;
      top: 10px;
      height: 25px;
      width: 25px;
      display: inline-block;
    }
  }

  .mobile-header {
    background: $grey-light;
    height: 60px;
    position: relative;
    z-index: $zindex-fixed;
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-title {
      @include font-weight-bold;
      text-transform: uppercase;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    .header-action {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .filter-clear-btn {
      text-transform: uppercase;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .close2 {
      width: 30px;
      height: 30px;
      vertical-align: middle;
    }

    .chevron-left {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
  }

  .mobile-filter-actions {
    position: fixed;
    bottom: 0;
    padding-right: 15px;
    padding-bottom: 15px;
    padding-left: 15px;
    width: 100%;
    z-index: $zindex-fixed;
  }

  .filter-brands {
    top: 50px;
  }
</style>
